import styles from "./styles.module.sass";
import { Formik } from "formik";
import Form from "react-bootstrap/Form";
import TextInput from "../Form/TextInput";
import { Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Checkbox from "../CheckboxForm";

function DebouncedInput({
  initialValue = "",
  onChange,
  debounce = 500,
  ...props
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

function Filters({ filters, globalFilter, onChangeGlobalFilterAction, props }) {
  const checkIfAgencyContainsAgent = (agenciesList, agencySelected) => {
    return props.agencies.find(() => {
      return agenciesList.find((ag) => ag._id === agencySelected);
    });
  };
  function prepareFilters(options, formName, values) {
    if (formName === "agent") {
      if (values.agency && values.agency !== "false") {
        return options.filter((option) =>
          checkIfAgencyContainsAgent(option.agencies, values.agency)
        );
      } else {
        return options.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          } else {
            return 1;
          }
        });
      }
    }
    return options;
  }
  return (
    <>
      {filters.mainSearch && (
        <div key={`0`}>
          {filters.mainSearch && (
            <>
              <h3>{filters.mainSearch.title}</h3>
              <span className={styles.search}>{filters.mainSearch.label}</span>
              <div className="pb-2">
                <DebouncedInput
                  initialValue={globalFilter ?? ""}
                  onChange={onChangeGlobalFilterAction}
                  className={styles.searchInput}
                  placeholder={filters.mainSearch.input}
                />
              </div>
              <hr />
            </>
          )}
        </div>
      )}
      {filters.subFilters && filters.subFilters.customSearch && (
        <div>
          <Formik
            onSubmit={(values) =>
              filters.subFilters.customSearch.button.action(values)
            }
            initialValues={{}}
          >
            {(props) => (
              <Form
                className="d-flex align-items-end mb-5"
                style={filters.subFilters.customSearch.style.div || ""}
              >
                <TextInput
                  style={filters.subFilters.customSearch.style.input || ""}
                  formName={filters.subFilters.customSearch.input.formName}
                  placeholder={filters.subFilters.customSearch.input.input}
                  label={filters.subFilters.customSearch.input.label}
                  {...props}
                />
                <Button
                  type="submit"
                  variant={
                    filters.subFilters.customSearch.button.variant
                      ? "outline-secondary"
                      : "btn-primary"
                  }
                  className={filters.subFilters.customSearch.class.button || ""}
                  style={filters.subFilters.customSearch.style.button || ""}
                  onClick={props.handleSubmit}
                >
                  {filters.subFilters.customSearch.button.label}
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      )}
      {filters.subFilters && filters.subFilters.moreFilters && (
        <div hidden={!filters.subFilters.moreFilters} key={`1`}>
          <Formik
            onSubmit={filters.subFilters.moreFiltersSubmitButton.action}
            initialValues={{}}
          >
            {(props) => (
              <Form style={{ width: "100%" }} as={Row}>
                {filters.subFilters.moreFilters.map((more, index) => (
                  <>
                    {more.dropdowns && (
                      <div
                        hidden={!more.dropdowns}
                        as={Row}
                        style={{
                          display: "grid",
                          grid: "auto-flow / 1fr 1fr 1fr 1fr",
                          gap: "24px",
                          marginBottom: "24px",
                        }}
                        key={`more-filters-dropsowns-${index}`}
                      >
                        {more.dropdowns.map((filter, index) =>
                          filter.type === "select" ? (
                            <>
                              <Form.Group
                                as={Col}
                                className="col-md-3 col-sm-6 col-12"
                                style={{ width: "100%" }}
                                key={`filter-option-${filter.formName}-${index}`}
                                controlId={filter.formName}
                              >
                                <Form.Label className={styles.label}>
                                  {filter.label}
                                </Form.Label>
                                <Form.Select onChange={props.handleChange}>
                                  <option value={false}>
                                    {filter.placeholder}
                                  </option>
                                  {prepareFilters(
                                    filter.options,
                                    filter.formName,
                                    props.values
                                  ).map((option) => (
                                    <option
                                      key={option.id}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </>
                          ) : (
                            <></>
                          )
                        )}
                      </div>
                    )}
                    {more.checkboxes && (
                      <div
                        hidden={!more.checkboxes}
                        key={`more-filters-checkboxes-${index}`}
                        as={Row}
                        style={{
                          display: "grid",
                          grid: "auto-flow / 1fr 1fr 1fr 1fr 1fr 1fr",
                          gap: "0 24px",
                        }}
                      >
                        {more.checkboxes.map((filter, index) =>
                          filter.type === "checkbox" ? (
                            <div
                              as={Col}
                              className="col-lg-2 col-md-4 col-sm-6 mb-3"
                              style={{ width: "100%" }}
                            >
                              <Checkbox
                                formName={filter.formName}
                                label={filter.label}
                                {...props}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )
                        )}
                      </div>
                    )}
                  </>
                ))}
                {filters.subFilters.moreFiltersSubmitButton && (
                  <button
                    type="button"
                    className={filters.subFilters.moreFiltersSubmitButton.style}
                    style={{ marginLeft: "10px" }}
                    onClick={props.handleSubmit}
                  >
                    {filters.subFilters.moreFiltersSubmitButton.label}
                  </button>
                )}
              </Form>
            )}
          </Formik>
        </div>
      )}
      {filters.subFilters && filters.subFilters.buttons && (
        <div
          hidden={!filters.subFilters.buttons}
          style={{ display: "flex", flexDirection: "row", margin: "25px 0" }}
          key={`2`}
        >
          {filters.subFilters.buttons.map((btn, index) => (
            <Button
              key={`filter-btn-${index}`}
              className={btn.style}
              onClick={btn.action}
            >
              {btn.label}
            </Button>
          ))}
        </div>
      )}
      {filters.filtersFooter && (
        <div hidden={!filters.filtersFooter}>{filters.filtersFooter}</div>
      )}
    </>
  );
}

export default Filters;
